'use client'

import { Toaster } from '@/components/ui/sonner'
import { envWeb } from '@/lib/env-web'
import { TRPCReactProvider } from '@/trpc/react'
import { ConfigDefaults } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import * as React from 'react'
import { AuthProvider } from './providers/auth-provider'
import ReactQueryProvider from './providers/react-query-provider'
import { ThemeProvider } from './providers/theme-provider'

const options = {
  api_host: envWeb.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24' as ConfigDefaults,
}

export function AllProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <ReactQueryProvider>
        <TRPCReactProvider>
          <AuthProvider>
            <PostHogProvider
              apiKey={envWeb.VITE_PUBLIC_POSTHOG_KEY}
              options={{
                ...options,
                session_recording: {
                  maskAllInputs: false,
                },
              }}
            >
              {children}
            </PostHogProvider>
          </AuthProvider>
        </TRPCReactProvider>
      </ReactQueryProvider>
      <Toaster />
    </ThemeProvider>
  )
}
